import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function amsTime() {
  return new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Amsterdam',
  }).format(new Date());
}

export default function NavBar() {
  const loc = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [clock, setClock] = useState(amsTime);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    const tick = setInterval(() => setClock(amsTime()), 30000);
    return () => { window.removeEventListener('scroll', onScroll); clearInterval(tick); };
  }, []);

  return (
    <nav className="site-nav" style={{
      background: scrolled ? 'rgba(246,240,215,0.85)' : 'var(--cream)',
      backdropFilter: scrolled ? 'blur(14px)' : 'none',
      WebkitBackdropFilter: scrolled ? 'blur(14px)' : 'none',
      color: 'var(--ink)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      height: 72,
      position: 'sticky', top: 0, zIndex: 100,
      transition: 'background 0.3s ease, box-shadow 0.3s ease',
      boxShadow: scrolled ? '0 1px 20px rgba(60,50,20,0.10)' : 'none',
    }}>
      {/* Brand — Hendriks-style stacked wordmark */}
      <Link to="/" style={{ textDecoration: 'none' }}>
        <span translate="no" style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: 1 }}>
          <span style={{ fontSize: 20, fontWeight: 700, color: 'var(--ink)', letterSpacing: '-0.02em' }}>
            DossierProof
          </span>
          <span className="nav-tag" style={{ fontSize: 9.5, fontWeight: 500, color: 'var(--text-label)', letterSpacing: '0.32em', marginTop: 3 }}>
            BY HENDRIKS HOUSING
          </span>
        </span>
      </Link>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span className="nav-clock">AMS {clock}</span>
        <Link
          to="/"
          className="nav-home-link"
          style={{
            color: loc.pathname === '/' ? 'var(--ink)' : 'var(--text-label)',
            textDecoration: 'none', fontSize: 14, fontWeight: 500,
            padding: '8px 14px', borderRadius: 999,
            transition: 'color 0.15s, background 0.15s',
            background: loc.pathname === '/' ? 'rgba(19,19,19,0.06)' : 'transparent',
          }}
        >
          Dashboard
        </Link>
        <Link
          to="/trends"
          className="nav-home-link"
          style={{
            color: loc.pathname === '/trends' ? 'var(--ink)' : 'var(--text-label)',
            textDecoration: 'none', fontSize: 14, fontWeight: 500,
            padding: '8px 14px', borderRadius: 999,
            transition: 'color 0.15s, background 0.15s',
            background: loc.pathname === '/trends' ? 'rgba(19,19,19,0.06)' : 'transparent',
          }}
        >
          Trends
        </Link>
        <Link to="/new" style={{ textDecoration: 'none' }}>
          <button
            className="btn btn-primary btn-dot btn-sm"
            style={{ marginLeft: 4 }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.03)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
          >
            New Analysis
          </button>
        </Link>
      </div>
    </nav>
  );
}
